import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { RefreshToken } from '../services/'
import { RefreshTokenResponse, UserToken } from 'typings/auth'

export async function getTokens(client: ApolloClient<NormalizedCacheObject>, userToken: UserToken) {
    try {
        if (userToken.token) {
            const { data } = await client.mutate<RefreshTokenResponse>({
                context: { headers: { authorization: 'expired' } },
                mutation: RefreshToken,
                variables: { token: userToken.refreshToken, KeepLogged: userToken?.keepLogged },
            })
            return { accessToken: data?.refreshToken.access_token, refreshToken: data?.refreshToken.refresh_token }
        }
        return { accessToken: null, refreshToken: null }
    } catch {
        throw new Error('Error getTokens')
    }
}
